import React from 'react';

interface ToolSectionProps {
  title: string;
  /** First section in a panel should pass `false` — nothing above it to separate from. */
  divider?: boolean;
  /** Rendered inline next to the title — e.g. an `InfoTooltip` icon. */
  titleExtra?: React.ReactNode;
  children: React.ReactNode;
}

export function ToolSection({ title, divider = true, titleExtra, children }: ToolSectionProps) {
  return (
    <div style={{
      display: 'flex', flexDirection: 'column', gap: 6,
      marginTop: divider ? 12 : 0,
      paddingTop: divider ? 12 : 0,
      borderTop: divider ? '1px solid var(--border)' : 'none',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 13, fontWeight: 600, color: 'var(--text)', marginBottom: 2 }}>
        {title}
        {titleExtra}
      </div>
      {children}
    </div>
  );
}
